import { createContext, useContext, type FC, type ReactNode } from "react";
import type { MastraChat } from "./useMastraChat.js";

const MastraChatContext = createContext<MastraChat | null>(null);

export interface MastraChatProviderProps {
  chat: MastraChat;
  children: ReactNode;
}

/**
 * Provides a `MastraChat` (from `useMastraChat`) to descendant chat components.
 * Replaces assistant-ui's `AssistantRuntimeProvider`; consumers read it via
 * `useMastraChatContext` instead of `useAui` / `useAuiState`.
 */
export const MastraChatProvider: FC<MastraChatProviderProps> = ({
  chat,
  children,
}) => (
  <MastraChatContext.Provider value={chat}>
    {children}
  </MastraChatContext.Provider>
);

export function useMastraChatContext(): MastraChat {
  const chat = useContext(MastraChatContext);
  if (!chat) {
    throw new Error(
      "useMastraChatContext must be used within a MastraChatProvider",
    );
  }
  return chat;
}
